import React from 'react'
import './footerStatus.css'

function FooterStatus(props) {

    let id = document.getElementById('section-footer-container')
    if (props.show) {
        if (!!id) {
            id.style.display = 'flex'
            setTimeout(() => {
                id.classList.add('animationToDown')
                setTimeout(() => {
                    id.style.display = 'none'
                    id.classList.remove('animationToDown')
                }, 500);
            }, 10000);
        }
    }

    return (
        <section
            id='section-footer-container'
            style={{ ...props.style }}
            className="footerStatus-container"
        >
            <div className="footerStatus-container_div">
                <h1 className='footerStatus-container_title'>{props.text}</h1>
                {/* <button className="footerStatus-container_button" onClick={() => {props.cancel(); return cancelAll()}}>
                    close
                </button> */}
                <progress className='footerStatus-container_progress' />
            </div>
        </section>
    );
}

export default FooterStatus